import AccountSet from '@/types/comparison-account-set';
import ComparisonItem from '@/types/comparison-item';

/**
 * Checks whether an account set has both current and primary recommended portfolios selected.
 *
 * @param accountSet - Account set to check
 * @param items - Proposal comparison items
 * @returns True when BOTH current AND primary recommended are selected
 */
export const accountSetHasSelectedPortfolioForView = (accountSet: AccountSet, items: ComparisonItem[]): boolean => {
  if (!accountSet) {
    return false;
  }

  const hasCurrentSelected = accountSet.current >= 0 && items[accountSet.current] !== undefined;
  const hasPrimaryRecommendedSelected = accountSet.recommendations.some(
    recommendation => recommendation.isPrimary && recommendation.itemId >= 0 && items[recommendation.itemId] !== undefined,
  );

  return hasCurrentSelected && hasPrimaryRecommendedSelected;
};

/**
 * Checks whether the proposal has at least one account set with BOTH a current and a primary recommended portfolio selected.
 */
export const proposalHasAnyAccountSetWithSelectedPortfolios = (accountSets: AccountSet[] | undefined, items: ComparisonItem[]): boolean => {
  return (accountSets || []).some(accountSet => accountSetHasSelectedPortfolioForView(accountSet, items));
};
